import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import store from 'store/Store';
import Actions from 'Actions';
import { Button } from 'components/ui';
import Modal from 'components/Modal/Modal';

function requestClose() {
    store.dispatch(Actions.showPromoInfoModal({ isOpen: false }));
}

function PromoInfoModal({ isOpen, title, description }) {
    return (
        <Modal
            isOpen={isOpen}
            onDismiss={requestClose}
            width={0}
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    dangerouslySetInnerHTML={{
                        __html: description
                    }}
                />
            </Modal.Body>
            <Modal.Footer textAlign='center'>
                <Button
                    width={['100%', 'auto']}
                    hasMinWidth={true}
                    variant='primary'
                    onClick={requestClose}
                >
                    Got it
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default wrapFunctionalComponent(PromoInfoModal, 'PromoInfoModal');
